import { Pipe, PipeTransform } from '@angular/core';
import { AccountNameData, AccountNameGetterService } from './account-name-getter.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Pipe({
  name: 'getAccountName',
  standalone: false,
})
export class GetAccountNamePipe implements PipeTransform {
  constructor(private readonly accountNameGetterService: AccountNameGetterService) {}

  transform(accountGroupId: string): Observable<string> {
    this.accountNameGetterService.loadAccountIfNotLoaded(accountGroupId);
    return this.accountNameGetterService.getAccount$(accountGroupId).pipe(
      map((a) => a.name),
      shareReplay(1),
    );
  }
}

@Pipe({
  name: 'getAccountData',
  standalone: false,
})
export class GetAccountDataPipe implements PipeTransform {
  constructor(private readonly accountNameGetterService: AccountNameGetterService) {}

  transform(accountGroupId: string): Observable<AccountNameData> {
    this.accountNameGetterService.loadAccountIfNotLoaded(accountGroupId);
    return this.accountNameGetterService.getAccount$(accountGroupId).pipe(shareReplay(1));
  }
}

@Pipe({
  name: 'isAccountDeleted',
  standalone: false,
})
export class IsAccountDeletedPipe implements PipeTransform {
  constructor(private readonly accountNameGetterService: AccountNameGetterService) {}

  transform(accountGroupId: string): Observable<boolean> {
    this.accountNameGetterService.loadAccountIfNotLoaded(accountGroupId);
    return this.accountNameGetterService.isAccountDeleted$(accountGroupId).pipe(shareReplay(1));
  }
}

@Pipe({
  name: 'isAccountLoading',
  standalone: false,
})
export class IsAccountLoadingPipe implements PipeTransform {
  constructor(private readonly accountNameGetterService: AccountNameGetterService) {}

  transform(accountGroupId: string): Observable<boolean> {
    this.accountNameGetterService.loadAccountIfNotLoaded(accountGroupId);
    return this.accountNameGetterService.accountLoading$(accountGroupId).pipe(shareReplay(1));
  }
}
